import { Text} from "@mantine/core";
import React, { useState, useEffect } from "react";
import Dygraphs from './Dygraphs';
import './App.css';
import helper from './helper';

const style = {
  cardBlock: {
    border: '1px solid rgba(34,36,38,.15)',
    boxShadow: '0 1px 2px 0 rgba(34,36,38,.15)',
    margin: 4,
    paddingTop: 16,
    backgroundColor: `rgba(192,193,191,.15)`,
  },
  cardHeader: {
    alignItems: 'center',
    display: 'flex',
    height: 32,
    justifyContent: 'space-between',
  },
  cardHeaderTitle: {
    flexGrow: 1,
  },
  cardHeaderTool: {
    height: 32,
    position: 'relative',
    width: 48,
    display: 'flex',
    gap: 8,
  },
  infoButton: {
    backgroundColor: '#dededf',
    borderWidth: 0,
    height: '100%',
    width: '100%',
  },
  legend: {
    fontSize: '0.8em',
    paddingLeft: 56,
    paddingTop: 5,
    textAlign: 'left',
  },
}

const movingAvg = [
  ["raw", 1],
  ["10M", 10],
  ["30M", 30],
  ["1H", 60],
  ["1D", 60*24]
];

const Indexdygraph = (props) => {
  const [graphData,setGraphData] = useState();
  const [handle,setHandle] = useState();
  const [rollPeriod,setRollPeriod] = useState(1);
  const [visible,setVisible] = useState([]);
  var formattedData = null;
  
  useEffect(() => {
    if (Array.isArray(props.data)) {
      formattedData = helper.toNativeFormat(props.data,"Native");
      setGraphData(formattedData);
      var initVisible = setItemVisibility(formattedData.labels);
      setVisible(initVisible);
  
    }
  },[props.data]);

  function setItemVisibility(labels) {
    let itemVisible = [];
    for ( var i=1; i < labels.length; i++) {
      itemVisible[i-1] = true;
    }
    return itemVisible;
  }

  const handleOnClick = (v) => {
    setRollPeriod(v[1]);
  }

//<div id="legendDiv" style={style.legend}></div>

  return ( 
    <>
    <div id="container">    
      <div style={{height:18}}/>
      { graphData && (
          <div style={style.cardBlock} >
            <div style={style.cardHeaderTool}>  
                { movingAvg.map(v => {
                  return ( 
                  <button
                    onClick={() => handleOnClick(v)}
                    style={style.infoButton}
                    type="button"
                  >
                    {v[0]}
                  </button>
                  );
                  })}  
            </div>
            <div id="legendDiv" style={style.legend}></div>
            <div  className="dygraphChart">         
              <Dygraphs
                data={graphData.values}
                formatTimestamp={helper.formatTimestamp}
                labels={graphData.labels}
                handle={handle}
                setHandle={setHandle}
                width={window.innerWidth - 400}
                height={window.innerHeight - 500}
                rollPeriod={rollPeriod}
                visible={visible}
                setVisible = {setVisible}
                legendDiv={document.getElementById("legendDiv")}
              />     
            </div>
          </div>
      )}
    </div>
    <div style={{fontSize: 11,}}>
      <br/>
      <Text fw={700} td="underline">dyGraph 차트 사용법</Text>
      <Text>1. 그룹, 장치, 시작일, 종료일 및 표시할 항목선택<br/> 
            2. 스위치에서 reChart 또는 dyGraph 선택<br/>
            3. 조회 버턴 클릭
      </Text><br/>
      <Text fw={700} td="underline"> 차트 좌측 상단 메뉴</Text>
      <Text>1.raw : 약 1분 간격의 실제 데이터(1분 동안의 최대값)<br/>
            2.10M ~ 1D : 10분,30분,1시간, 1일 이동 평균
      </Text><br/>
      <Text fw={700} td="underline"> 차트  하단 리스트</Text>
      <Text> 선택한 항목 리스트이며 좌측의 select박스를 클릭하면 해당 항목 보이기/숨기기 토글됨
      </Text><br/>
      <Text fw={700} td="underline"> 줌 기능</Text>
      <Text>1.마우스 왼쪽 클릭후 좌우 또는 상하로 드래그 하면 선택된 영역이 줌되어짐<br/>
            2.또는 차트 하단의 좌우에 있는 아이콘을 움직이면 줌영역을 선택할수 있고 
              선택된 영역을 드래그 하면 다른 영역으로 그래프가 움직임<br/>
            3.그래프 영역에서 더블클릭하면 원래 사이즈로 돌아감
      </Text><br/>
      <Text fw={700} td="underline"> 그래프 리사이즈</Text>
      <Text> 1.그래프 우측하단의 모서리에서 빗금선을 마우스를 드래그하면 그래프가 리사이징 되어짐</Text>
    </div>
    </> 
  );

}

export default Indexdygraph;

/*
  return (
    <div className="Chart">
      { graphData && graphData.map(
        ({ labels, values, index }, i) => {
        return (
          <div style={style.cardBlock} >
            <div
              style={{
                ...style.cardHeader,
                cursor: 'grabbing',
              }}
            >
              <div style={style.cardHeaderTitle}>
                {index}
              </div>
              <div style={style.cardHeaderTool}>
                <button
                  onClick={handleOnClick}
                  style={style.infoButton}
                  type="button"
                >
                  보기
                </button>
              </div>
            </div>
            <Dygraphs
              data={values}
              index={index}
              formatTimestamp={helper.formatTimestamp}
              labels={labels}
            />
          </div>
        );
      })}
   </div>
  );
*/